// Hydration bundle entry — loaded by every generated /{slug}/index.html.
// Registers the doc-system and seeds it with the modules live examples may
// `import`, so an inline `import { b3dAircraft } from 'tosijs-3d'` resolves.

import 'tosijs-ui' // the tosi-* element family
// Since tosijs-ui 1.15 the barrel NO LONGER registers the doc-authoring
// elements — they are opt-in subpaths. Without these two the site renders its
// prerendered markup and nothing else (no nav, no live examples, no console
// error). Caught by the 0.8.4 publish dry run's build warning.
import 'tosijs-ui/doc-browser'
import 'tosijs-ui/live-example'
import * as tosijs from 'tosijs'
import * as tosijs3d from '../src/index'
import * as tosijsui from 'tosijs-ui'
import * as rigTool from '../src/rig-tool'
import * as effectTool from '../src/effect-tool'
import * as demoUtils from './demo-utils' // shared "when in doubt" helpers for live examples
// Point live examples' asset lookups (assetUrl) at the shared CDN.
tosijs3d.setAssetBase('https://cdn.tosijs.net')

// Show the 📊 perf/debug toggle on every live demo across the doc site (each
// scene's own toolbar). A dev/authoring affordance — library consumers don't get
// it unless they opt in per scene (`stats`) or via `#perf`.
tosijs3d.showB3dStats()
// Only where a dev server is answering: the live site has no such endpoint.
if (location.hostname !== '3d.tosijs.net') {
  tosijs3d.debugSink.url = '/__debug-sink'
  // Enough frames to see what recurses in a stack overflow (the default is 10).
  ;(Error as any).stackTraceLimit = 60
}

// <tosi-doc-system> only reads .context inside render(), which awaits the
// docs.json fetch its connectedCallback kicks off — so a synchronous assignment
// here, right after the imports register the element, lands well in time.
for (const el of document.querySelectorAll('tosi-doc-system')) {
  ;(el as any).context = {
    tosijs,
    'tosijs-3d': tosijs3d,
    'tosijs-ui': tosijsui,
    // The PUBLISHED specifier, so a snippet copied off a page resolves in a
    // consumer's project unchanged. `demo-utils` stays registered for the
    // handful of examples that use the site-only helpers (volumetricDemo,
    // impactMarker, the asset constants).
    'tosijs-3d/demo-utils': demoUtils,
    'tosijs-3d/rig-tool': rigTool,
    'tosijs-3d/effect-tool': effectTool,
    'demo-utils': demoUtils,
  }
}
